// rootReducer.js
import { combineReducers } from 'redux';
import userReducer from './user/reducer';
import newOrderReducer from './new-order/reducer';
import locationReducer from './location/reducer';


const rootReducer = combineReducers({
  user: userReducer,
  newOrder: newOrderReducer,
  location: locationReducer,
});

export default rootReducer;
